import Cmp from './modules/cmp';
import Commercial from './modules/commercial';
import Gallery from './modules/gallery';
import Carousel from './modules/carousel';
import SharingTools from './modules/sharingtools';
import Tabs from './modules/tabs';
import Togglers from './modules/togglers';
import Global from './modules/global';
import ReadingList from './modules/readinglist';
import CommentedItems from './modules/commenteditems';
import Members from './modules/members';
import Account from './modules/account';

const modules = {
  Cmp,
  Commercial,
  Gallery,
  Carousel,
  SharingTools,
  Tabs,
  Togglers,
  Global,
  ReadingList,
  CommentedItems,
  Members,
  Account
};

var elements = document.querySelectorAll('.js-modules');
if (elements.length > 0) {
  for (let i = 0; i < elements.length; i++) {
    var options = JSON.parse(elements[i].text || elements[i].textContent);
    options.modules.forEach((module) => {
      if (modules[module.name]) {
        new modules[module.name](module.options);
      }
    });
  }
}
